import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebook, faLinkedin, faTelegram, faInstagram } from "@fortawesome/free-brands-svg-icons";
import './index.css';

class ShareButton extends Component {

  constructor(props) {
    super(props);
    this.state = { shareButtonsDisplay:"none" }
    this.clickHandler = this.clickHandler.bind(this);
    this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
  }


  clickHandler(e) {

  }

  mouseEnterHandler(e) {
    const { vertical } = this.props;
    if(vertical){this.setState({shareButtonsDisplay:"block"})}
    else {this.setState({shareButtonsDisplay:"flex"})}
  }

  mouseLeaveHandler(e) {
    this.setState({shareButtonsDisplay:"none"})
  }



  render() {
    const {lang, style, className, vertical, iconSize, showLeft } = this.props;
    const { shareButtonsDisplay } = this.state;
    const _iconSize = iconSize ? iconSize : vertical ? '30px' : '18px';
    const _right =  vertical ? '0' : showLeft ? '70px' : '-185px';
    return (
      <div className='cb-share-button-container'>
        <button style={style} onClick={this.clickHandler} onMouseEnter={this.mouseEnterHandler}
          onMouseLeave={this.mouseLeaveHandler} className={className + ' cb-share-button'}>
          {lang === 'fa' ? 'اشتراک گذاری + ' : 'Share + '}
          <div className='cb-share-buttons-wrapper'
            style={{display:shareButtonsDisplay, right: _right, paddingLeft:  vertical ? '0' : '30px',
              top: vertical ? '40px': '4px', height: vertical ? 'auto' : '35px', width:  vertical ? '100%' :'auto',
              fontSize: _iconSize, borderTop: vertical ? '1px solid rgba(255, 255, 255, 1)': 'none', direction:showLeft? 'rtl' : 'ltr',
              paddingRight: vertical ? '0px' : showLeft ? '30px' : '0'}}>
            <div><FontAwesomeIcon icon={faFacebook}/></div>
            <div><FontAwesomeIcon icon={faLinkedin }/></div>
            <div><FontAwesomeIcon icon={faTelegram}/></div>
            <div><FontAwesomeIcon icon={faInstagram}/></div>
            <div><FontAwesomeIcon icon={faTwitter}/></div>
          </div>
        </button>
      </div>
    );
  }
}


export default ShareButton;
